import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type RecommendationModel from './recommendation';
import type ScanModel from './scan';
import type SectionModel from './section';

export const DOMAIN_OPTIONS: Record<string, { label: string; icon: string }> = {
  ENGINEERING: {
    label: 'Engineering',
    icon: 'tailwind-icons/wrench-screwdriver',
  },
  PRODUCT: {
    label: 'Product',
    icon: 'tailwind-icons/package',
  },
  ROADMAP: {
    label: 'Roadmap',
    icon: 'atoms/icons/roadmap',
  },
  SECURITY: {
    label: 'Security',
    icon: 'tailwind-icons/shield-check',
  },
  INFRASTRUCTURE: {
    label: 'Infrastructure',
    icon: 'tailwind-icons/network',
  },
  QUALITY: {
    label: 'Quality',
    icon: 'tailwind-icons/code-xml',
  },
  ORGANISATION: {
    label: 'Organisation',
    icon: 'tailwind-icons/briefcase',
  },
};

export default class ObservationModel extends Model {
  declare [Type]: 'observation';
  @attr('string') declare title: string;
  @attr declare description: string;
  @attr('boolean') declare is_featured: boolean;
  @attr('string') declare generation_method: string;
  @attr('string') declare domain: string | null;
  @attr('string') declare sentiment: string;
  @attr declare created_at: string;
  @attr declare updated_at: string;

  @belongsTo('scan', {
    async: true,
    inverse: 'observations',
  })
  declare scan: AsyncBelongsTo<ScanModel>;

  @hasMany('recommendation', {
    async: true,
    inverse: 'observation',
  })
  declare recommendations: AsyncHasMany<RecommendationModel>;

  @belongsTo('section', {
    async: true,
    inverse: 'observations',
  })
  declare section: AsyncBelongsTo<SectionModel>;

  get isExpertVerified() {
    return this.generation_method === 'EXPERT_REVIEWED';
  }

  get areasAffected(): string[] {
    return [];
  }

  get domainLabel() {
    return (
      DOMAIN_OPTIONS[this.domain?.toUpperCase() ?? '']?.label ??
      this.domain ??
      'Other'
    );
  }

  get domainIcon() {
    return (
      DOMAIN_OPTIONS[this.domain?.toUpperCase() ?? '']?.icon ||
      'atoms/icons/question-mark'
    );
  }
}
